import { IItin, Itin } from './../../core/itinerari/itinerari.model';

export class PaginatedItin {
  list: IItin[];
  size: number;
  page: number;
  total: number;

  static from(obj: any): PaginatedItin {
    return {
      list: Itin.fromArray(obj.list),
      size: obj.size,
      page: obj.page,
      total: obj.total,
    };
  }
}
